module.exports = __webpack_public_path__ + "static/media/CCU_Arg-14.8126c68d.png";